import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { domain } from '@/utils/domain'

import { apiUserInfo } from '@/api/user'

// 创建请求
const service = axios.create({
  // baseURL: process.env.API, // 请求地址
  // withCredentials: true, // 跨域请求时发送cookie
  timeout: 5000 // 请求超时
})
// 创建请求
const service1 = axios.create({
  // baseURL: '/service',
  timeout: 5000 // 请求超时
})
// 请求拦截
service1.interceptors.request.use(
  config => {

    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

const isDev = process.env.NODE_ENV === 'development' ? true : false;
const realm = process.env.NODE_ENV === 'testing' ? 'https://cs-www.hbgyl.com.cn' : 'https://www.hbgyl.com.cn';


// 请求拦截器
service.interceptors.request.use(
  async config => {
    // const EncodeUserInfo = localStorage.getItem('EncodeUserInfo')
    if (['openapi'].includes(config.url.split('/')[1]) && !isDev) {
      try {
        // 调用用户信息接口
        const resp = await apiUserInfo()
        console.log('用户信息获取成功', resp)
      } catch (err) {
        console.error('获取用户信息失败', err)
        window.location.href = 'https://login.hbgyl.com.cn/login?response_type=code&appId=cbbeb2d9-6097-4dc0-8e3e-02109114c045&redirect_uri=https://www.hbgyl.com.cn/dmdp-homepage/sync/SSO/login.do?frontRedirectUrl=aHR0cHM6Ly93d3cuaGJneWwuY29tLmNuLyMvc2VydmljZUNlbnRlcg=='

        // 不再跳转，而是返回错误，由响应拦截器统一处理
        return Promise.reject(new Error('用户信息获取失败'))
      }
    } else {
      const reg = /^WJ\//

      if (reg.test(config.url)) {
        const d = config.url.split('/')[0]
        const wj = process.env.NODE_ENV === 'testing' ? 'https://cs-wl.hbgyl.com.cn/api/zhyy' : 'https://wl.hbgyl.com.cn/api/zhyy';
        config.url = wj + config.url.replace(d, '')
      } else if (!isDev) {
        const d = config.url.split('/')[0]
        config.url = realm + config.url.replace(d, '')
      }
      // 发送请求之前做一些处理
      if (store.getters.token) {
        // 请求头携带token
        config.headers['token'] = ''
      }
    }
    return config
  },
  error => {
    // 请求错误
    console.log(error)
    return Promise.reject(error)
  }
)

// 请求拦截-响应
service.interceptors.response.use(
  response => {
    const res = response.data
    res.code = res.code || res.Code || 200

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200 && res.code !== 1) {
      // Message({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 500) {
        // Message({
        //   message: res.msg || 'warning',
        //   type: 'warning',
        //   duration: 5 * 1000
        // })
        // store.dispatch('user/logout')
        // 重新登录
        // MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
        //   confirmButtonText: 'Re-Login',
        //   cancelButtonText: 'Cancel',
        //   type: 'warning'
        // }).then(() => {
        //   store.dispatch('user/resetToken').then(() => {
        //     location.reload()
        //   })
        // })
      }
      return Promise.reject(new Error(res.Msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)
export { service1 }
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js